<template>
  <div class="container lms-wrapper-two">
    
    <student-nav />

    <div class="lms-content" @click="closeLevel2()">
      <student-header :navbarmode.sync="navbarMode" ref="lmsv4header" class="filled" />
     
      <div class="lms-content-body" style="height: calc(100vh - 80px)">
        
      
      <vue-custom-scrollbar class="" style="height: calc(100vh - 80px);">
        <div class="container-fluid mg-y-30">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb breadcrumb-style4 mg-b-10">
              <li class="breadcrumb-item">
                <router-link v-if="hasPermission(['buddy_worker'])" :to="{ name: 'buddyWorker' }" class="tx-11" style="color: #444">
                  Buddy ажилтан
                </router-link>
                <router-link v-else-if="hasPermission(['buddy_chief'])" :to="{ name: 'buddyChief' }" class="tx-11" style="color: #444">
                  Нэгжийн удирдлага
                </router-link>
                <router-link v-else-if="hasPermission(['lmsbuddyadmin'])" :to="{ name: 'buddyAdminDashboard' }" class="tx-11" style="color: #444">
                  Onboarding хөтөлбөр
                </router-link>
              </li>
              <li class="breadcrumb-item active tx-14" aria-current="page">Унших материал</li>
            </ol>
          </nav>


          <div class="row">
            <div v-for="(t,ti) in tasks" class="col-xxl-2 col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12">
              <div @click="readItem(t)" role="button" class="bg-white pd-15 rounded-20">
                <div class="">
                  <!-- <img src="https://res.gosmart.mn/apps/golomt/quiz1.png" style="max-width: 68px" /> -->
                  <img :src="`${t.defaultAttachmentUrl}`" style="max-width: 68px" />
                  <div class="mb-2 tx-semibold mg-t-30 ">{{ t.task }}</div>
                  <div class="leading-tight text-gray-500">{{ t.taskEn }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vue-custom-scrollbar>
    </div>

    </div>

    <b-modal v-model="task.rdy" centered hide-footer size="lg" :title="task.obj.task">
      <img :src="task.obj.secondAttachmentUrl" class="object-cover w-full h-64 mb-4 rounded-lg shadow-lg" />
      <div v-html="task.obj.taskDesc"></div>
    </b-modal>


    <!-- <b-sidebar id="sidebar" v-model="task.rdy" title="Sidebar" backdrop right
    class="sidebar-custom">
      <template #default>
        <h5>Sidebar Content</h5>
        <p>This is some content for the sidebar.</p>
      </template>
      <template #modal-footer>
        <b-button variant="secondary" @click="task.rdy = false">Close</b-button>
      </template>
    </b-sidebar> -->
  </div>
</template>

<script>
import { mapActions } from "vuex";

import vueCustomScrollbar from "vue-custom-scrollbar";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";



import { request } from "@/api/all";
import { getConfigValueByKey } from "@/libs/util";

import { localSave, localRead } from "@/libs/util";

const moment = require("moment");

import "element-ui/lib/theme-chalk/index.css";
import { Notification } from "element-ui";

import { hasOneOf } from "@/libs/tools";

export default {
  components: {
    vueCustomScrollbar,
    
    userCover: () => ({
      component: import("@/views/modules/lms/components/userCover.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentHeader: () => ({
      component: import("@/views/modules/lms/student/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentCalendar: () => ({
      component: import("@/views/modules/lms/teacher/components/calendar.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    partUserSidebar: () => ({
      component: import( "@/views/modules/lms/student/parts/userSidebar.vue" ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    return {
      myResBaseUrl: "https://res.gosmart.mn/",
      mdl:{
        show: false
      },
      curInd: 0,
      navbarMode: 0,
      mustJoinCourses: {
        all: 0,
        finished: 0,
      },
      tasks: [],
      task:{
        obj: {},
        rdy: false
      },
    };
  },
  // beforeCreate() {
  //   require('@/assets/scss/pages/learning.scss');
  // },
  created() {
    this.fetchResBase();
  },
  mounted() {
    this.init();
  },
  destroyed() {
    // this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    hasPermission(arr) {
      if (this.$store.state.user.userId == "") return false;
      return hasOneOf(this.$store.state.user.userInfo.access, arr);
    },
    readItem(task) {
      this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "GET", url: "Task/TaskInheritedDetail" },
          params: { id: task.id },
          store: this.$store,
        }).then((res) => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if(res!=false){
            this.task.obj= res.data.task;
            this.task.rdy= true;
            console.log('res', res.data.task);
          }
        });
      // this.$router.push({
      //   name: 'buddyQuizFill',
      //   params: {id: n}
      // })
    },
    logout(){
      this.$refs.lmsv4header.logout();
    },
    fetchResBase() {
      if (
        this.$store.state.app.activeGroup.resBaseUrl != undefined &&
        this.$store.state.app.activeGroup.resBaseUrl != ""
      ) {
        this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
      }
    },
    ...mapActions(["handleAside", "resetResponsiveLayoutConfig", "handleMainLayoutConfig"]),
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    closeLevel2() {
      if (this.$store.state.app.responsiveLayout.level2.show)
        this.resetResponsiveLayoutConfig(document);
    },
    
    getConfigValueByKey(key) {
      return getConfigValueByKey(this.$store.state.app.groupSettings, key);
    },
    init() {
      let _pid = 0;
      let proj = this.$store.state.app.groupDefaultProjects.filter(
        (x) => x.objectTypeId == 617
      );
      if (proj.length) {
        _pid = proj[0].id;
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "POST", url: "TaskCore/GetCoreList" },
          data: {
            projectId: _pid,
            skip: 0,
            size: 200,
            model: {
              isPublic: true
            },
          },
          store: this.$store,
        }).then((res) => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if(res!=false){
            this.tasks= res.data.tasks;
          }
        });
      }
    },
    
  },
};
</script>
<style lang="scss">
.sidebar-custom {
  .sidebar{
    border: 2px solid red;
    width: 100% !important; /* Full width on small screens */
  }
}

@media (min-width: 992px) { /* Large screens and up */
  .sidebar-custom {
    width: 70% !important; /* 70% width on large screens */
  }
}
</style>